import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as d3 from 'd3';
import { simplePlaceName, pplural, commas, impactSort, isUS, xlt } from '../../utils/utils';
import { Link } from 'react-router';
import AutoWidthSelect from '../AutoWidthSelect';
import ToggleText from '../ToggleText';
import styles from './ImpactGroup.css';
import withStyles from '../../decorators/withStyles';


class ImpactGroup extends Component {

  static propTypes = {
    placeName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    waterLevel: PropTypes.object.isRequired,
    selected: PropTypes.string.isRequired,
    impactPct: PropTypes.bool.isRequired,
    impacts: PropTypes.array.isRequired,
    impactName: PropTypes.string.isRequired,
    subcategoryExclusions: PropTypes.object.isRequired,
    // srcCaption: PropTypes.object.isRequired,
    isEmbed: PropTypes.bool.isRequired,
    toggleProtection: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selected: false
  };

  handleClick(impact) {
    this.props.handleClick(impact);
  }

  setTxContent = el => {
    d3.select(el).attr("tx-content", "block");
  };

  render() {
    const { impactName, name, impacts, waterLevel, factCriteria } = this.props;
    // const { srcCaption, impactName, name, impacts, waterLevel, factCriteria } = this.props;
    if (impacts.length > 0 && impacts[0].water_level_values[waterLevel.unit] === undefined) {
      return null;
    }

    function pretrans(impact) {
      if (impact.key in factCriteria && factCriteria[impact.key].pretransform) {
        return val => factCriteria[impact.key].pretransform(val);
      } else {
        return val => val;
      }
    }
    function posttrans(impact) {
      if (impact.key in factCriteria && factCriteria[impact.key].posttransform) {
        return val => factCriteria[impact.key].posttransform(val)
      } else {
        return val => val;
      }
    }

    var self = this;
    // Sort by name if this is the only group available;
    // Otherwise, sort by value (as defined by impactSort)
    var sortF;
    if (this.props.numGroups === 1) {
      sortF = (a, b) => a.name < b.name ? -1 : 1;
    } else {
      sortF = impactSort.bind(this, this.props.waterLevel, this.props.impactPct);
    }
    // For an impact, get that impact's relevant subgroup.
    // Ugly hack; TODO: fix this at the data level.
    function inSubroupFilter(impact, subgroup) {
      if (subgroup === "Race & ethnicity" && (impact.key === "Population_native" || impact.key === "Population_hisp")) {
        return true;
      } else {
        return impact.groups.find(group => group[0] === self.props.name)[1] === subgroup;
      }
    }

    const subgroups = [...new Set(impacts.map(impact => impact.groups[0][1]))]
      .map(subgr => {return {text: subgr, value: subgr}})
      .filter(obj => obj.text && obj.value);
    const select = <AutoWidthSelect options={[{text: "All", value: "All"}, ...subgroups]}
                                    handleChange={this.props.handleSubgroupSelection}
                                    defaultValue={this.props.impactSubgroup} />
    return (
      <div className="ImpactGroup-container">
        <div className="ImpactGroup">
          <div className="ImpactGroup-scroller">
            <table>
              <thead>
              <tr className="header">
                {this.props.numGroups === 1 ?
                    <th className="impact"><div>Variable</div></th>
                    : <th className="impact"><div>{name}: {select}</div></th>
                }
                {this.props.impactPct ?
                  <th className="value"><div>Percent</div></th>
                  : <th className="value"><div>Total</div></th>
                }
              </tr>
              </thead>
              <tbody>
              {this.props.impacts.filter(impact => {
                const valAtWaterLevel = impact.water_level_values[self.props.waterLevel.unit][self.props.waterLevel.level];
                return !this.props.noData(null, impact) && valAtWaterLevel > 0 && (this.props.impactSubgroup === "All" ? true: inSubroupFilter(impact, this.props.impactSubgroup));
              }).sort(sortF).map((impact, i) => {
                var valAtWaterLevel = pretrans(impact)(impact.water_level_values[self.props.waterLevel.unit][self.props.waterLevel.level]);
                const pctAtWaterLevel = valAtWaterLevel / impact.total * 100;
                return <tr key={impact.name}
                           onClick={this.handleClick.bind(this, impact)}
                           className={(impact.key === this.props.selected ? "selected " : " ") + (i % 2 ? "even" : "odd")}>
                  <td className="impact">{xlt(impact.name)}</td>
                  {this.props.impactPct ? <td className="value">{pctAtWaterLevel.toFixed(1)}</td>
                    : <td className="value" dangerouslySetInnerHTML={
                      {__html: `<var>${commas((posttrans(impact)(valAtWaterLevel))).split(" ")[0]}</var> ` +
                               `${commas(posttrans(impact)(valAtWaterLevel)).split(" ").slice(1).join(" ")}`
                      }
                    } />
                  }
                </tr>;
              })}
              {!this.props.impacts.find(impact => {
                const valAtWaterLevel = impact.water_level_values[self.props.waterLevel.unit][self.props.waterLevel.level];
                return !this.props.noData(null, impact) && valAtWaterLevel > 0 && (this.props.impactSubgroup === "All" ? true: inSubroupFilter(impact, this.props.impactSubgroup));
              }) ? <tr><td>No exposure in this category under current settings</td><td></td></tr> : null}
              </tbody>
            </table>
          </div>
        </div>

        {this.props.children}

        {/* this.props.selected !== "Land" ?
            <div className="map-explain">
              {srcCaption}
            </div>
            : null */}
        
        {isUS(this.props.placeID) ?
        <p ref={this.setTxContent} key={Math.random()}>Values&nbsp;
          <ToggleText>
            <span onClick={this.props.toggleProtection}>{(this.props.protection === "protected" ? "exclude" : "include")}</span>
          </ToggleText> sub-<var>{waterLevel.level}</var><var>{waterLevel.unit}</var> areas potentially protected by levees or other features.&nbsp;
          <Link to={{pathname: "/about", hash: "#about-levees", state: {modal: true, modalTitle: "About this site",
                                                                        returnTo: location.pathname}}}>
            <span className="icon question-mark" />
          </Link>
        </p>
            :
            null}
      </div>
    );

  };
}

export default withStyles(styles)(ImpactGroup);
